import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const { massiveAction } = config.endpoints

const createMassiveAction = data => axios({
  method: 'post',
  url: massiveAction,
  data,
  headers: getHeaders(true)
})

export default {
  createMassiveAction
}
